var map = {
	"./views/administration/banneres/banneres.module": [
		"../../../../../src/app/views/administration/banneres/banneres.module.ts",
		"common",
		"banneres.module"
	],
	"./views/administration/fotos/fotos.module": [
		"../../../../../src/app/views/administration/fotos/fotos.module.ts",
		"common"
	],
	"./views/administration/galerias/galerias.module": [
		"../../../../../src/app/views/administration/galerias/galerias.module.ts",
		"common",
		"galerias.module"
	],
	"./views/administration/habitaciones/habitaciones.module": [
		"../../../../../src/app/views/administration/habitaciones/habitaciones.module.ts",
		"common",
		"habitaciones.module"
	],
	"./views/administration/planes/planes.module": [
		"../../../../../src/app/views/administration/planes/planes.module.ts",
		"common",
		"planes.module"
	],
	"./views/administration/precios/precios.module": [
		"../../../../../src/app/views/administration/precios/precios.module.ts",
		"common",
		"precios.module"
	],
	"./views/administration/reservas/reservas.module": [
		"../../../../../src/app/views/administration/reservas/reservas.module.ts",
		"common",
		"reservas.module"
	],
	"./views/administration/tipologias/tipologias.module": [
		"../../../../../src/app/views/administration/tipologias/tipologias.module.ts",
		"common",
		"tipologias.module"
	],
	"./views/administration/valores/valores.module": [
		"../../../../../src/app/views/administration/valores/valores.module.ts",
		"common",
		"valores.module"
	],
	"./views/administration/videos/videos.module": [
		"../../../../../src/app/views/administration/videos/videos.module.ts",
		"common",
		"videos.module"
	],
	"./views/pagina/pagina.module": [
		"../../../../../src/app/views/pagina/pagina.module.ts",
		"pagina.module",
		"common"
	],
	"./views/security/security.module": [
		"../../../../../src/app/views/security/security.module.ts",
		"common",
		"security.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// C:/repos/Tulaima/Tulaima-ng/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main